const tw = {
  index: {
    avatamsaka: '大方廣佛華嚴經',
    webContra: '藏漢比對',
    cateList: '經書列表',
    aboutContrast: '關於藏漢比對',
    aboutTeam: '關於我們',
  },
};

export default tw;



// WEBPACK FOOTER //
// ./src/i18n/langs/tw/homepage.js